"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactReduxI18n = require("react-redux-i18n");

var _DocumentDossierChips = _interopRequireDefault(require("../DocumentDossierChips"));

var _TextCheckbox = _interopRequireDefault(require("../TextCheckbox"));

var _Icon = _interopRequireDefault(require("../Icon"));

var _documents = require("../../utils/documents");

var _jsxRuntime = require("react/jsx-runtime");

function DownloadExcelTemplate(props) {
  var _React$useState = _react.default.useState(false),
      _React$useState2 = (0, _slicedToArray2.default)(_React$useState, 2),
      noForeignWorkers = _React$useState2[0],
      setNoForeignWorkers = _React$useState2[1];

  var handleDownloadTemplate = function handleDownloadTemplate(event) {
    event.preventDefault();
    event.stopPropagation();

    if (noForeignWorkers) {
      return;
    }

    window.open(props.pathDocumentTemplate);
  };

  var handleSubmit = function handleSubmit(event) {
    event.preventDefault();
    props.onHandleSubmit(noForeignWorkers);
  };

  return /*#__PURE__*/(0, _jsxRuntime.jsx)("form", {
    onSubmit: handleSubmit,
    children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      className: "col-12",
      children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
        className: "inline-container space-between col-12",
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("h3", {
          className: "m-0",
          children: props.document.type.name
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_DocumentDossierChips.default, {
          dossiers: props.document.dossiers
        })]
      }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
        className: "col-12 mt-4 p-4 clickable",
        onClick: handleDownloadTemplate,
        style: {
          borderRadius: '4px',
          border: 'dashed 2px',
          borderColor: '#d8d8d8',
          display: 'flex',
          flexDirection: 'column',
          boxSizing: 'border-box',
          alignItems: 'center'
        },
        children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
          className: "inline-container column center",
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_Icon.default, {
            icon: "download",
            size: 80
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactReduxI18n.Translate, {
            value: "document.downloadExcelTemplateMessage"
          })]
        }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("button", {
          type: "button",
          className: "small primary inline-container mt-5",
          onClick: handleDownloadTemplate,
          "data-id": "downloadTemplateButton",
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_reactReduxI18n.Translate, {
            value: "document.downloadExcelTemplate"
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Icon.default, {
            icon: "download"
          })]
        })]
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_TextCheckbox.default, {
          onChange: function onChange() {
            return setNoForeignWorkers(!noForeignWorkers);
          },
          label: /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactReduxI18n.Translate, {
            value: "document.noForeignWorkers"
          })
        })
      }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
        className: "actions col-12 inline-container space-between",
        children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("button", {
          type: "button",
          className: "large secondary inline-container",
          onClick: props.onClose,
          "data-id": "cancel",
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_reactReduxI18n.Translate, {
            value: "action.cancel"
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Icon.default, {
            icon: "go-back"
          })]
        }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("button", {
          id: "submit",
          className: "large inline-container primary",
          type: "submit",
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_reactReduxI18n.Translate, {
            value: noForeignWorkers ? 'action.confirm' : 'action.continue'
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Icon.default, {
            icon: noForeignWorkers ? 'check' : 'arrow-right'
          })]
        })]
      })]
    })
  });
}

DownloadExcelTemplate.propTypes = {
  document: (0, _documents.documentPropTypes)().isRequired,
  onClose: _propTypes.default.func.isRequired,
  onHandleSubmit: _propTypes.default.func.isRequired,
  pathDocumentTemplate: _propTypes.default.string.isRequired,
  onClickProject: _propTypes.default.func
};
var _default = DownloadExcelTemplate;
exports.default = _default;
//# sourceMappingURL=DownloadExcelTemplate.js.map